import React, { useState } from "react";
import { Grid } from "@mui/material";
import { Form, Button, Spinner } from "react-bootstrap";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";

const LoginScreen = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailValid, setEmailValid] = useState(false);
  const [passwordValid, setPasswordValid] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const handleEmailChange = (e) => {
    const emailValue = e.target.value;
    setEmail(emailValue);
    setEmailValid(validateEmail(emailValue));
  };

  const handlePasswordChange = (e) => {
    const passwordValue = e.target.value;
    setPassword(passwordValue);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (emailValid && passwordValid) {
      setIsLoading(true);
      console.log("Form submitted:", { email, password });
      try {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          username: email,
          password: password,
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        var response = await fetch(
          `${API_URL}/admin/login-user`,
          requestOptions,
        );
        if (response.ok) {
          const data = await response.json();

          const { token, user } = data;
          console.log("Login successful:", data);
          if (user.type == "admin" || user.type == "owner") {
            // if (user.companies) {
            localStorage.setItem("loggedIn", "true");
            localStorage.setItem("user", "false");
            localStorage.setItem("token", token);
            localStorage.setItem("userId", user._id);
            if (user.company && user.company._id) {
              localStorage.setItem("companyID", user.company._id);
            }
            // localStorage.setItem("companies", JSON.stringify(user.companies));
            if (user.companies && Array.isArray(user.companies)) {
              localStorage.setItem("companies", JSON.stringify(user.companies));
            } else {
              localStorage.setItem("companies", JSON.stringify([]));
            }
            localStorage.setItem("permission", user.permissions);
            localStorage.setItem("type", user.type);
            window.location.reload();
            // window.location.href = "/admin";

            // } else {
            // alert("This organization is disabled. Please contact support!");
            // }
          } else {
            localStorage.setItem("loggedIn", "true");
            localStorage.setItem("user", "false");
            localStorage.setItem("token", token);
            localStorage.setItem("userId", user._id);
            localStorage.setItem("permission", user.permissions);
            localStorage.setItem("type", user.type);
            window.location.reload();
          }
          setIsLoading(false);
        } else {
          // If response is not ok, show alert for incorrect username or password
          localStorage.setItem("loggedIn", "false");
          setIsLoading(false);
          alert("Incorrect username or password. Please try again.");
          console.error("Login failed");
        }
      } catch (error) {
        console.error("Error during login:", error);
        localStorage.setItem("loggedIn", "false");
        setIsLoading(false);
        alert("An error occurred during login. Please try again later.");
      }
    } else {
      alert("Please fill in all fields correctly.");
    }
  };

  const validateEmail = (email) => {
    // Simple email validation
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  return (
    <Grid
      container
      spacing={0}
      justifyContent="center"
      alignItems="center"
      style={{ height: "100vh", fontFamily: "Noto Sans" }}
    >
      <Grid
        item
        xs={7}
        style={{
          justifyContent: "center",
          alignContent: "center",
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <img
          src={require("../assets/login_back_admin.png")}
          alt="Login"
          style={{ width: "70%", height: "auto" }}
        />
      </Grid>
      <Grid
        item
        xs={5}
        style={{
          backgroundColor: "#000000",
          height: "100%",
          justifyContent: "center",
          alignContent: "center",
          alignItems: "center",
          display: "flex",
        }}
      >
        <Grid
          item
          xs={7}
          style={{
            flexDirection: "column",
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
            display: "flex",
          }}
        >
          <img
            src={require("../assets/FLP_Logo_500 x 500.png")}
            alt="Login"
            style={{ width: "70%", height: "auto", marginBottom: "75px" }}
          />
          <p
            style={{
              fontSize: "24px",
              fontWeight: "600",
              fontFamily: "Noto Sans",
              color: "#FFFFFF",
            }}
          >
            Control Center Bharat FLP
          </p>
          <Form
            style={{ fontFamily: "Noto Sans" }}
            className="w-100"
            onSubmit={handleSubmit}
          >
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label
                style={{
                  fontWeight: "500",
                  borderRadius: "20px",
                  color: "#FFFFFF",
                }}
              >
                Email address
              </Form.Label>
              <Form.Control
                type="email"
                placeholder="name@example.com"
                className="w-100"
                style={{ width: "100%", borderRadius: "20px" }}
                value={email}
                onChange={handleEmailChange}
                isInvalid={email !== "" && !emailValid}
              />
              <Form.Control.Feedback type="invalid">
                Please enter a valid email address.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label
                htmlFor="inputPassword5"
                style={{
                  fontWeight: "500",
                  borderRadius: "20px",
                  color: "#FFFFFF",
                }}
              >
                Password
              </Form.Label>
              <Form.Control
                type="password"
                id="inputPassword5"
                aria-describedby="passwordHelpBlock"
                style={{ width: "100%", borderRadius: "20px" }}
                value={password}
                onChange={handlePasswordChange}
                isInvalid={password !== "" && !passwordValid}
              />
              <Form.Control.Feedback type="invalid">
                Password must be at least 9 characters long.
              </Form.Control.Feedback>
            </Form.Group>
            <Button
              style={{
                fontWeight: "600",
                borderRadius: "20px",
                marginTop: "15px",
              }}
              elevation={3}
              className="w-100"
              variant="primary"
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : null}{" "}
              Login
            </Button>
          </Form>
          <div
            style={{ flexDirection: "row", display: "flex", margin: "15px" }}
          >
            <p
              style={{
                fontSize: "14px",
                fontWeight: "bold",
                fontFamily: "Noto Sans",
                marginRight: "5px",
                color: "#FFFFFF",
              }}
            >
              Interested,{" "}
            </p>
            <p
              style={{
                fontSize: "14px",
                fontWeight: "bold",
                fontFamily: "Noto Sans",
                color: "red",
              }}
            >
              Contact Us Now!
            </p>
          </div>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default LoginScreen;
